module.exports = __webpack_public_path__ + "img/02.f4144a45.png";